import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-type-manual",
  "use": "foquz-icon-type-manual-usage",
  "viewBox": "0 0 17 19",
  "content": "<symbol viewBox=\"0 0 17 19\" fill=\"none\" id=\"foquz-icon-type-manual\"><path d=\"M13.437 17.5l1.932-3.22.001-.001-.002.004a.9.9 0 00.13-.467V9.329a.904.904 0 00-.659-.867L9.425 6.5v-4c0-2-3-2-3 0v7.202l-2-.702c-1.5-.5-2-1-2.784-.347a.905.905 0 00-.256.976.9.9 0 00.181.304L7.425 17.5h6.012z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol